// garuda - SVG Icons and Backgrounds

import React from "react";

// Door Icon - Entry to home
export const DoorIcon = ({ className, style, onClick }) => (
  <svg
    className={className}
    style={style}
    onClick={onClick}
    width="60"
    height="80"
    viewBox="0 0 60 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="5"
      y="5"
      width="50"
      height="70"
      stroke="#888888"
      strokeWidth="2"
      fill="none"
    />
    <circle cx="45" cy="40" r="3" fill="#888888" opacity="0.6" />
    <line
      x1="30"
      y1="5"
      x2="30"
      y2="75"
      stroke="#888888"
      strokeWidth="1"
      opacity="0.3"
    />
  </svg>
);

// Pencil Tip Icon - Broken graphite
export const PencilIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2 L8 8 L10 8 L10 20 L14 20 L14 8 L16 8 Z"
      stroke="#888888"
      strokeWidth="1.5"
      fill="none"
    />
    <line
      x1="12"
      y1="2"
      x2="12"
      y2="5"
      stroke="#888888"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

// Fountain Pen Nib Icon
export const PenNibIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2 L12 16 M8 10 L12 16 L16 10 M12 16 L12 22"
      stroke="#888888"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="1" fill="#888888" />
  </svg>
);

// Folder Icon - Weathered
export const FolderIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 6 L3 18 L21 18 L21 8 L12 8 L10 6 Z"
      stroke="#888888"
      strokeWidth="1.5"
      fill="none"
    />
    <line
      x1="3"
      y1="10"
      x2="21"
      y2="10"
      stroke="#888888"
      strokeWidth="1"
      opacity="0.5"
    />
  </svg>
);

// Clock Icon - No hands
export const ClockIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="#888888"
      strokeWidth="1.5"
      fill="none"
    />
    <circle cx="12" cy="12" r="1.5" fill="#888888" />
  </svg>
);

// Skeleton Key Icon
export const KeyIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="7"
      cy="7"
      r="4"
      stroke="#888888"
      strokeWidth="1.5"
      fill="none"
    />
    <line x1="10" y1="10" x2="20" y2="20" stroke="#888888" strokeWidth="1.5" />
    <line x1="15" y1="15" x2="15" y2="17" stroke="#888888" strokeWidth="1.5" />
    <line x1="18" y1="18" x2="18" y2="20" stroke="#888888" strokeWidth="1.5" />
  </svg>
);

// Spectacles Icon - Overlapping circles
export const SpectaclesIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8"
      cy="12"
      r="5"
      stroke="currentColor"
      strokeWidth="1.2"
      fill="none"
    />
    <circle
      cx="16"
      cy="12"
      r="5"
      stroke="currentColor"
      strokeWidth="1.2"
      fill="none"
    />
    <line
      x1="13"
      y1="12"
      x2="11"
      y2="12"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
);

// Admin Icons (10px minimal)
export const PlusIcon = ({ className, style, onClick }) => (
  <svg
    className={className}
    style={style}
    onClick={onClick}
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="5" y1="0" x2="5" y2="10" stroke="#888888" strokeWidth="1.5" />
    <line x1="0" y1="5" x2="10" y2="5" stroke="#888888" strokeWidth="1.5" />
  </svg>
);

export const EditIcon = ({ className, style, onClick }) => (
  <svg
    className={className}
    style={style}
    onClick={onClick}
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8 L0 10 L2 10 L8 4 L6 2 Z M6 2 L8 0 L10 2 L8 4 Z"
      fill="#888888"
    />
  </svg>
);

export const DeleteIcon = ({ className, style, onClick }) => (
  <svg
    className={className}
    style={style}
    onClick={onClick}
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="1" y1="1" x2="9" y2="9" stroke="#888888" strokeWidth="1.5" />
    <line x1="9" y1="1" x2="1" y2="9" stroke="#888888" strokeWidth="1.5" />
  </svg>
);

// Background SVG Symbols
export const TerminalPromptBg = ({ opacity = 0.05 }) => (
  <svg
    style={{
      position: "absolute",
      top: "10%",
      left: "5%",
      width: "200px",
      height: "200px",
      opacity: opacity,
      pointerEvents: "none",
      zIndex: 0,
    }}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <text
      x="10"
      y="150"
      fontSize="180"
      fill="#888888"
      fontFamily="JetBrains Mono, monospace"
    >
      $
    </text>
  </svg>
);

export const HashtagBg = ({
  opacity = 0.05,
  offset = { x: "10%", y: "5%" },
}) => (
  <svg
    style={{
      position: "absolute",
      top: offset.y,
      left: offset.x,
      width: "300px",
      height: "300px",
      opacity: opacity,
      pointerEvents: "none",
      zIndex: 0,
    }}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50 60 L40 140 M90 60 L80 140 M30 80 L120 90 M20 120 L110 130"
      stroke="#888888"
      strokeWidth="12"
      strokeLinecap="round"
    />
  </svg>
);

export const AmpersandBg = ({ opacity = 0.05 }) => (
  <svg
    style={{
      position: "absolute",
      top: "10%",
      left: "5%",
      width: "250px",
      height: "250px",
      opacity: opacity,
      pointerEvents: "none",
      zIndex: 0,
    }}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M80 60 Q60 80 60 100 Q60 120 80 140 L120 180 M80 140 Q100 120 120 100 Q140 80 140 60 Q140 40 120 30 Q100 20 80 30 Q60 40 60 60"
      stroke="#888888"
      strokeWidth="8"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export const TildeBg = ({ opacity = 0.05 }) => (
  <svg
    style={{
      position: "absolute",
      top: "15%",
      left: "10%",
      width: "200px",
      height: "200px",
      opacity: opacity,
      pointerEvents: "none",
      zIndex: 0,
    }}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 100 Q60 60 100 100 Q140 140 180 100"
      stroke="#888888"
      strokeWidth="12"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export const ParenthesesBg = ({ opacity = 0.05 }) => (
  <svg
    style={{
      position: "absolute",
      top: "10%",
      left: "5%",
      width: "220px",
      height: "220px",
      opacity: opacity,
      pointerEvents: "none",
      zIndex: 0,
    }}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M80 40 Q40 100 80 160"
      stroke="#888888"
      strokeWidth="10"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M120 40 Q160 100 120 160"
      stroke="#888888"
      strokeWidth="10"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export const BracketsBg = ({ opacity = 0.05 }) => (
  <svg
    style={{
      position: "absolute",
      top: "10%",
      left: "5%",
      width: "200px",
      height: "200px",
      opacity: opacity,
      pointerEvents: "none",
      zIndex: 0,
    }}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M80 40 L60 40 L60 160 L80 160"
      stroke="#888888"
      strokeWidth="10"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M120 40 L140 40 L140 160 L120 160"
      stroke="#888888"
      strokeWidth="10"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export const CurlyBracesBg = ({ opacity = 0.05 }) => (
  <svg
    style={{
      position: "absolute",
      top: "10%",
      left: "5%",
      width: "220px",
      height: "220px",
      opacity: opacity,
      pointerEvents: "none",
      zIndex: 0,
    }}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M80 40 Q70 40 70 50 L70 85 Q70 95 60 100 Q70 105 70 115 L70 150 Q70 160 80 160"
      stroke="#888888"
      strokeWidth="8"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M120 40 Q130 40 130 50 L130 85 Q130 95 140 100 Q130 105 130 115 L130 150 Q130 160 120 160"
      stroke="#888888"
      strokeWidth="8"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

// Hand-drawn circle SVG component
export const HandDrawnCircle = ({ bbox, onAnimationComplete }) => {
  if (!bbox) return null;

  const { x, y, radiusX, radiusY } = bbox;
  const pathData = generateHandDrawnPath(x, y, radiusX, radiusY);

  return (
    <svg
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 1000,
      }}
    >
      <path
        d={pathData}
        className="svg-circle"
        onAnimationEnd={onAnimationComplete}
      />
    </svg>
  );
};

// Helper to generate hand-drawn oval path
const generateHandDrawnPath = (centerX, centerY, radiusX, radiusY) => {
  const points = [];
  const segments = 36;
  const wobbleX = radiusX * 0.08;
  const wobbleY = radiusY * 0.08;

  for (let i = 0; i <= segments; i++) {
    const angle = (i / segments) * Math.PI * 2;
    const randomWobbleX = (Math.random() - 0.5) * wobbleX;
    const randomWobbleY = (Math.random() - 0.5) * wobbleY;
    const rx = radiusX + randomWobbleX;
    const ry = radiusY + randomWobbleY;
    const x = centerX + rx * Math.cos(angle);
    const y = centerY + ry * Math.sin(angle);
    points.push([x, y]);
  }

  let path = `M ${points[0][0]},${points[0][1]}`;

  for (let i = 1; i < points.length; i++) {
    if (i < points.length - 1) {
      const midX = (points[i][0] + points[i + 1][0]) / 2;
      const midY = (points[i][1] + points[i + 1][1]) / 2;
      path += ` Q ${points[i][0]},${points[i][1]} ${midX},${midY}`;
    } else {
      path += ` Q ${points[i][0]},${points[i][1]} ${points[0][0]},${points[0][1]}`;
    }
  }

  return path;
};

// Social Icons
export const GithubIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.17 6.839 9.49.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.34-3.369-1.34-.454-1.156-1.11-1.463-1.11-1.463-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0112 6.836c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.167 22 16.418 22 12c0-5.523-4.477-10-10-10z"
      fill="#888888"
    />
  </svg>
);

export const LinkedInIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
      fill="#888888"
    />
  </svg>
);

// Share Icon - Copy link
export const ShareIcon = ({ className, style, onClick }) => (
  <svg
    className={className}
    style={style}
    onClick={onClick}
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18" cy="5" r="3" stroke="#888888" strokeWidth="2" fill="none" />
    <circle cx="6" cy="12" r="3" stroke="#888888" strokeWidth="2" fill="none" />
    <circle
      cx="18"
      cy="19"
      r="3"
      stroke="#888888"
      strokeWidth="2"
      fill="none"
    />
    <line
      x1="8.5"
      y1="13.5"
      x2="15.5"
      y2="17.5"
      stroke="#888888"
      strokeWidth="2"
    />
    <line
      x1="8.5"
      y1="10.5"
      x2="15.5"
      y2="6.5"
      stroke="#888888"
      strokeWidth="2"
    />
  </svg>
);

// Mail Icon
export const MailIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
      fill="#888888"
    />
  </svg>
);

// Instagram Icon
export const InstagramIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"
      fill="#888888"
    />
  </svg>
);

// Image File Icon
export const ImageFileIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
      fill="#888888"
    />
  </svg>
);

// Video File Icon
export const VideoFileIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
      fill="#888888"
    />
  </svg>
);

// Audio File Icon
export const AudioFileIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z"
      fill="#888888"
    />
  </svg>
);

// PDF File Icon
export const PdfFileIcon = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"
      fill="#888888"
    />
  </svg>
);
